import { addBankWallet, setBankWallets } from '../reducers/bankWalletsReducer';

export const addedBankWallet = (dispatch, wallet) => {
  dispatch(addBankWallet(wallet));
};
export const removeBankWallet = (key) => ({ 
  type: 'bankWallets/removeBankWallet',
  payload: { key }
});

export const removeBankWalletAll = () => ({
  type: 'bankWallets/removeBankWalletAll',
});

export const updateBankWallets = (dispatch, wallets) => { 
  dispatch(setBankWallets(wallets));
}